import { render, staticRenderFns } from "./HomeWork.vue?vue&type=template&id=08694aa8&"
import script from "./HomeWork.vue?vue&type=script&lang=js&"
export * from "./HomeWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports